// src/pages/PainelAgendamentos/StatusAgendamentoCards.jsx
import { useState, useEffect } from "react";
import {
  ListChecks,
  Clock,
  CheckCircle2,
  XCircle,
  CalendarCheck,
} from "lucide-react";

export default function StatusAgendamentoCards({
  statusCounts = {},
  onSelectStatus,
  activeKey,
}) {
  const [active, setActive] = useState(null);

  // Definição dos cards (com as keys normalizadas)
  const defaults = {
    todos: 0,
    pendente: 0,
    concluido: 0,
    cancelado: 0,
    reagendado: 0,
  };

  const counts = { ...defaults, ...(statusCounts || {}) };

  const cards = [
    {
      key: "",
      title: "Todos",
      count: counts.todos,
      color: "bg-slate-500",
      light: "bg-slate-100",
      icon: <ListChecks className="text-slate-600" size={22} />,
    },
    {
      key: "pendente",
      title: "Pendentes",
      count: counts.pendente,
      color: "bg-yellow-500",
      light: "bg-yellow-100",
      icon: <Clock className="text-yellow-600" size={22} />,
    },
    {
      key: "concluido",
      title: "Concluídos",
      count: counts.concluido,
      color: "bg-green-500",
      light: "bg-green-100",
      icon: <CheckCircle2 className="text-green-600" size={22} />,
    },
    {
      key: "cancelado",
      title: "Cancelados",
      count: counts.cancelado,
      color: "bg-red-500",
      light: "bg-red-100",
      icon: <XCircle className="text-red-600" size={22} />,
    },
    {
      key: "reagendado",
      title: "Reagendados",
      count: counts.reagendado,
      color: "bg-blue-500",
      light: "bg-blue-100",
      icon: <CalendarCheck className="text-blue-600" size={22} />,
    },
  ];

  // Atualiza o card ativo quando activeKey mudar
  useEffect(() => {
    if (activeKey !== undefined) {
      setActive(
        activeKey === "" ? 0 : cards.findIndex((c) => c.key === activeKey)
      );
    }
  }, [activeKey]);

  return (
    <div className="grid grid-cols-5 gap-4 p-4">
      {cards.map((card, index) => (
        <div
          key={card.key}
          onClick={() => {
            setActive(index);
            if (onSelectStatus) {
              onSelectStatus(card.key);
            }
          }}
          className={`relative ${card.light} p-3 rounded-md shadow-sm border 
                      flex flex-col items-center justify-center h-28 
                      cursor-pointer transition-transform duration-200
                      hover:shadow-lg hover:scale-105
                      ${active === index ? "border-b-4 border-black" : ""}`}
        >
          {/* Faixa no topo sempre */}
          <div
            className={`absolute top-0 left-0 w-full h-2 rounded-t-md ${card.color}`}
          />

          <div className="flex flex-col items-center justify-center mt-2">
            <div className="mb-1">{card.icon}</div>
            <h3 className="font-semibold text-slate-700 text-sm">
              {card.title}
            </h3>
            <p className="text-lg font-bold text-slate-800 mt-1">
              {card.count}
            </p>
            <span className="text-xs text-slate-500">ITENS</span>
          </div>
        </div>
      ))}
    </div>
  );
}
